GP.vent.on("init_js:user:hotpick init_js:user:home", function(self) {
    var hotpick_rated_today = 0;
    var hon_user_queue = [];
    var hon_user_count = 10;
    var photo_stack_count = 0;
    var action_btns = $('#hotpick-wrap').find('#action-buttons');
    var hotpick_notify = $('#hotpick-notify');
    var processing = false;
    var notify_processed = false;
    var hotpick_disable_swiping = false;
    var verified_limit = 10;
    var get_on_top_limit = 20;
    var verified_card_cookie_name = 'fl_ver_card_shown';
    var got_card_cookie_name = 'fl_got_card_shown';
    var stealth_mode_cookie_name = 'fl_hon_stealth_modal_shown';
    var check_for_upsell = false;

    var hon_man_limit = 200;

    var GET_ON_TOP_CREDIT_COST = 100;

    if (window._priority_msg_credit_cost) {
        GET_ON_TOP_CREDIT_COST = parseInt(window._get_on_top_credit_cost, 10);
    }

    self.disable_buttons = function() {
        action_btns.addClass('loading');
    };

    self.enable_buttons = function() {
        action_btns.removeClass('loading');
    };

    self.get_swipe_users = function(init, refresh) {
        refresh = (typeof refresh !== 'undefined') ? refresh : false;

        get_vals = {
            'get_users' : 1,
            'user_count' : hon_user_count,
            'media_size' : 'L',
            'sort_desc' : 1,
        };

        if (refresh) {
            get_vals.refresh = 1;
        }

        $.get('/members/user/hot_or_not/', get_vals).done(function(json) {
            if (json.limit_reached) {
                if (GP.sdata.my_user.membership == 'BRONZE') {
                    self.swipe_limit_reached_bronze(json);
                } else {
                    self.swipe_limit_reached(json);
                }
                return;
            }

            if (json.users.length === 0) {
                self.swipe_users_reached();
                return;
            }

            if (json.users) {
                hon_user_queue = hon_user_queue.concat(json.users);
                photo_stack_count = hon_user_queue.length;
                self.show_swipe_user();
            }

            if (init) {
                hotpick_rated_today = parseInt(json.rated_today_count, 10);
                self.check_verified_card(hotpick_rated_today);
                self.check_got_card(hotpick_rated_today);

                self.update_swipe_totals();
                $('.swipe-progress').removeClass('hide');
                $('.hotpick-item-after').removeClass('hide');
                $('.progress_dt > .text-rate-wrap').removeClass('hide');
                setTimeout(() => {
                    $('.progress_dt > .text-rate-wrap').addClass('gone');
                }, "5000");
                setTimeout(() => {
                        $('.progress_dt > .text-rate-wrap').addClass('hide');
                }, "5500");
                processing = false;
            }
            self.reset_favorite_btn();
        })
        .always(function() {
            processing = false;
        });
    };
    self.show_swipe_user = function() {
        if (hon_user_queue.length) {
            var duids = [];
            var user_count = hon_user_queue.length;

            // display match game after loading
            $('#hotpick_img_box').show();
            //$('#hotpick-wrap #info-wrap').show();

            $("#hotpick-swipe-list").html('');
            for (var i = 0; i < user_count; i++) {
                var user = hon_user_queue.pop();
                var status= (user.user.status) ? 'ico-online-green ico-online-green-default' : '';
                var like_ico = "<div class='like'><span class='fl-sp fl-ico-hotpick-like-lg'></span></div>";
                var dislike_ico = "<div class='dislike'><span class='fl-sp fl-ico-hotpick-dislike-lg'></span></div>";
                var interests_overlay = '';
                if (user.user.likes_weed) {
                    interests_overlay = '<img src="https://cachemd.fling.com/images/interests-weed.png" class="interests-overlay" />';
                } else if (user.user.likes_games) {
                    interests_overlay = '<img src="https://cachemd.fling.com/images/interests-games.png" class="interests-overlay" />';
                } else if (window._full_domain_name.match(/wealthymen\.com/i) && user.user.high_income) {
                    interests_overlay = '<img src="https://cachemd.fling.com/images/diamond_wealthymen.com.png" class="interests-overlay" />';
                } else if (window._full_domain_name.match(/richmen\.com/i) && user.user.high_income) {
                    interests_overlay = '<img src="https://cachemd.fling.com/images/diamond_richmen.com.png" class="interests-overlay" />';
                }

                var verified_badge = '';
                if (user.user.verified) {
                    verified_badge = '<span class="verified-badge" data-toggle="tooltip"><svg width="24" height="24" viewBox="0 0 24 24" class="icon-acv" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6,2.1C11.8,2,12.1,2,12.3,2l0.1,0l9,4C21.8,6.2,22,6.6,22,7l0,0.1l-0.6,5.2c-0.3,2.6-1.7,5-3.9,6.5 l-0.3,0.2l-4.7,2.9c-0.3,0.2-0.6,0.2-0.9,0.1l-0.1-0.1l-4.7-2.9c-2.2-1.4-3.8-3.7-4.1-6.3l0-0.3L2,7.1c0-0.4,0.1-0.8,0.5-1l0.1-0.1 L11.6,2.1z" fill="#0085FF"></path><path d="M15.3,6.8c0.5-0.6,1.5-0.8,2.1-0.3c0.6,0.5,0.7,1.3,0.4,1.9l-0.1,0.2l-6,7.5c-0.5,0.7-1.5,0.8-2.1,0.3l-0.1-0.1 l-3-3c-0.6-0.6-0.6-1.5,0-2.1c0.5-0.5,1.4-0.6,2-0.1l0.1,0.1l1.8,1.8L15.3,6.8z" fill="#FFFFFF"></path></svg></span>';
                }

                var verified_class = '';
                if (user.user.verified) {
                    verified_class = 'verified';
                }

                var verified_label = '';
                if (user.user.verified) {
                    verified_label = '<div class="verified_label touch-ignore"><a href="/members/user/verify" data-event="Modal:open" class="touch-ignore">Verified</a><svg x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"> <path d="M8.6,3.5C8.7,3.6,8.8,3.8,8.8,4S8.7,4.5,8.6,4.6C8.4,4.8,8.2,4.8,8,4.8S7.6,4.8,7.4,4.6S7.2,4.3,7.2,4s0.1-0.4,0.2-0.6 S7.8,3.2,8,3.2S8.4,3.3,8.6,3.5z M8,6.4c-0.2,0-0.4,0.1-0.6,0.2S7.2,7,7.2,7.2V12c0,0.2,0.1,0.4,0.2,0.6c0.2,0.2,0.4,0.2,0.6,0.2 s0.4-0.1,0.6-0.2c0.2-0.1,0.2-0.4,0.2-0.6V7.2c0-0.2-0.1-0.4-0.2-0.6C8.4,6.5,8.2,6.4,8,6.4z M16,8c0,4.4-3.6,8-8,8s-8-3.6-8-8 s3.6-8,8-8S16,3.6,16,8z M14.4,8c0-1.7-0.7-3.3-1.9-4.5C11.3,2.3,9.7,1.6,8,1.6S4.7,2.3,3.5,3.5C2.3,4.7,1.6,6.3,1.6,8 s0.7,3.3,1.9,4.5c1.2,1.2,2.8,1.9,4.5,1.9s3.3-0.7,4.5-1.9S14.4,9.7,14.4,8z"/> </svg></div>';
                }

                var media_num = user.pic_num;
                var media_container = "<div class='thumb media-item' style='background-image: url("+ user.pic_src + ")'>"+ interests_overlay +"</div>";

                if (typeof user.vid_num != 'undefined' && user.vid_num) {
                    media_num = user.vid_num;
                    media_container = "<video class='video media-item' playsinline loop autoplay muted><source src='"+ user.vid_src +"' type='video/mp4'></video>";
                }

                var media_type = user.media_type;

                var gender_indicator = "<span class='gender-indicator'>";
                var gender_icon = '<svg class="icon-gender" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.4375 0H6.1875C5.87813 0 5.625 0.253125 5.625 0.5625C5.625 0.871875 5.87813 1.125 6.1875 1.125H7.07625L4.84312 3.35813C4.34812 3.015 3.74625 2.8125 3.09375 2.8125C1.38375 2.8125 0 4.19625 0 5.90625C0 7.61625 1.38375 9 3.09375 9C4.80375 9 6.1875 7.61625 6.1875 5.90625C6.1875 5.25375 5.985 4.65188 5.64187 4.15125L7.875 1.92375V2.8125C7.875 3.12188 8.12813 3.375 8.4375 3.375C8.74687 3.375 9 3.12188 9 2.8125V0.5625C9 0.253125 8.74687 0 8.4375 0ZM3.09375 7.875C2.00813 7.875 1.125 6.99188 1.125 5.90625C1.125 4.82062 2.00813 3.9375 3.09375 3.9375C4.17938 3.9375 5.0625 4.82062 5.0625 5.90625C5.0625 6.99188 4.17938 7.875 3.09375 7.875Z" fill="currentColor"/></svg>';
                if (user.user.gender == 'WOMAN') {
                    gender_icon = '<svg class="icon-gender" width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.99149 3.72646C6.99149 5.26696 5.89753 6.55196 4.44409 6.84698V7.54752H5.71829V8.82121H4.44409V9.45798H3.1704V8.82121H1.89722V7.54752H3.1704V6.84698C1.71698 6.55194 0.623047 5.26695 0.623047 3.72646C0.623047 1.96786 2.04867 0.542236 3.80727 0.542236C5.56586 0.542236 6.99149 1.96786 6.99149 3.72646ZM3.80653 5.63723C4.86169 5.63723 5.71706 4.78185 5.71706 3.72669C5.71706 2.67154 4.86169 1.81616 3.80653 1.81616C2.75137 1.81616 1.896 2.67154 1.896 3.72669C1.896 4.78185 2.75137 5.63723 3.80653 5.63723Z" fill="currentColor"/></svg>';
                    gender_indicator = "<span class='gender-indicator gender-woman'>";
                }
                gender_indicator += gender_icon + "<span class='text-age'>"+user.user.age+"</span></span>";

                var ai_chatbot_feature = '';
                var ai_chatbot_badge = '';
                if (user.user.is_ai_chatbot) {
                    ai_chatbot_feature = '<div class="chatbot-feature-wrap"><div class="feature-ct">'+'<span class="icon-wrap">'+_ai_chatbot_icon+'</span>'+
                                         '<span class="text-notice"><strong>New Feature!</strong> Swipe right to chat with our AI Companion!</span>'+'</div></div>';

                    ai_chatbot_badge = '<span class="ai-badge-wrap">'+_ai_chatbot_icon+'AI Companion <span class="text-sm">(beta)</span></span>';
                    gender_indicator = '';
                    verified_badge = '';
                }

                var $pic_html =
                    $("<li class='hotpick-item " + verified_class + "'><div class='ct'>"+ like_ico + dislike_ico + media_container +"</div>"+ verified_label +
                    "<div class='user-info'><p class='text-username-wrap'><a href='/members/user/profile/?duid="+user.duid+"' target='_blank'>"+
                    "<span class='"+status+"'></span> <span class='text-username touch-ignore'>"+user.user.username+ "</span>"+
                    "</a>"+verified_badge+gender_indicator+ai_chatbot_badge+"</p><p class='text-location'>" +user.user.location+"</p>"+ai_chatbot_feature+"</div></li>");
                    $pic_html.find('.media-item').attr({ duid:user.duid, gender:user.user.gender, media_num:media_num, media_type:media_type});
                $('#hotpick-swipe-list').append($pic_html);
            }

            // disable swiping for desktop users
            if (MoshPit.get_size() == 'desktop' || MoshPit.get_size() == 'desktop-wide') {
                hotpick_disable_swiping = true;
            }

            self.destroy();
            self.setup_jTinder();

            if (check_for_upsell) {
                self.check_verified_card(hotpick_rated_today);
                self.check_got_card(hotpick_rated_today);
                check_for_upsell = false;
            }

            if (MoshPit.get_size() == 'desktop' || MoshPit.get_size() == 'desktop-wide') {
                GP.vent.trigger('User:setup_verified_tooltip', $('.verified-badge'));
            }
        }
    };

    self.setup_jTinder = function() {
        $("#hotpick-swipe").jTinder({
            // dislike callback
            onDislike: function (item) {
                if (item.hasClass('verified-card-wrap') || item.hasClass('got-card-wrap') || item.hasClass('get-more-swipes-wrap')) {
                    processing = false;
                } else {
                    // set the status text
                    var _item = item.find('.media-item');

                    var swipe_data = {
                        rating: 'DISLIKE',
                        duid: _item.attr('duid'),
                        gender: _item.attr('gender'),
                        media_num: _item.attr('media_num'),
                        media_type: _item.attr('media_type'),
                        add_rating: 1
                    };

                    self.process_swipe(swipe_data);
                }
            },
            // like callback
            onLike: function (item) {
               if (item.hasClass('verified-card-wrap')) {
                // show verified profile modal
                self.show_verified_modal();
                processing = false;
               } else if (item.hasClass('got-card-wrap')) {
                // show get on top modal
                self.show_got_modal();
                processing = false;
               } else {
                    // set the status text
                    var _item = item.find('.media-item');
                    var swipe_data = {
                        rating: 'LIKE',
                        duid: _item.attr('duid'),
                        gender: _item.attr('gender'),
                        media_num: _item.attr('media_num'),
                        media_type: _item.attr('media_type'),
                        add_rating: 1,
                    };

                    self.process_swipe(swipe_data);
                }
            },
            animationRevertSpeed: 200,
            animationSpeed: 400,
            threshold: 1,
            likeSelector: '.like',
            dislikeSelector: '.dislike',
            disableSwiping: hotpick_disable_swiping
        });
    };

    self.process_swipe = function(swipe_data) {
        if (!GP.sdata.my_user.has_pic) {
            self.show_upload_notice();
            return;
        }

        if (GP.sdata.my_user.only_x) {
            self.show_upload_notice_x();
            return;
        }

        if (hotpick_notify.is(':checked') && !notify_processed) {
            swipe_data.notify_msg_id = hotpick_notify.val();
        }

        GP.api.json('user.hot_or_not', {
            type: 'POST',
            data: swipe_data,
        }).done(function(json) {
            if (swipe_data.rating === 'LIKE' || swipe_data.rating === 'CUTE') {
                hotpick_rated_today++;
            }

            photo_stack_count--;

            if (photo_stack_count === 0) {
                self.get_swipe_users();
                // this will check for the Verified and Get on Top card
                // after fetching new users. Prevents a display issue.
                check_for_upsell = true;
            } else {
                self.check_verified_card(hotpick_rated_today);
                self.check_got_card(hotpick_rated_today);
            }

            notify_processed = true;
            if (!$.cookie('fl_htpck')) {
                GP.Util.set_cookie('fl_htpck', 1, 1);
                self.hide_notify();
            }

            if (json.limit_reached) {
                if (GP.sdata.my_user.membership == 'BRONZE') {
                    self.swipe_limit_reached_bronze(json);
                } else {
                    self.swipe_limit_reached(json);
                }
            } else {
                self.update_swipe_totals();
            }

            if (json.stealth_lvl_2_reward) {
                self.show_goal_50_reached();
            } else if (json.featured_1_day_reward) {
                self.show_1_day_featured_reached();
            } else if (json.featured_7_days_reward) {
                self.show_7_days_featured_reached();
            } else if (json.featured_30_days_reward) {
                self.show_30_days_featured_reached();
            }

            // bronze user thread unlock modal (newer modal)
            if (json.mutual_match && json.allow_send_msg === false && GP.sdata.my_user.membership == 'BRONZE') {
                // open modal to spend/purchase credits if thread isn't unlocked
                var user_model = new GP.models.User({duid: json.user.duid});
                user_model.thread_json()
                    .done(function(thread_json) {
                        if (GP.Util.check_obj(thread_json)) {
                            GP.vent.trigger('Modal:open', {
                                url: '/members/billing/unlock_thread_modal/',
                                duid: json.user.duid,
                                is_match_game: true,
                                price: json.thread_unlock_price,
                                thread_json: thread_json,
                            }, fireConfetti());
                        }
                    })
                    .fail(function() {
                        // maybe close right drawer here if we fail to get the thread_json?
                    });
            } else if (json.mutual_match) {
                // free / promo user send message upgrade (old modal)
                self.show_match_modal(json);
            }

            processing = false;

            self.reset_favorite_btn();

        });
    };

    self.show_match_modal = function(json) {
        var $modal = $('#hon-match-modal');
        $modal.find('.my-info img').attr('src', GP.sdata.my_user.pic);
        $modal.find('.my-info span').html(GP.sdata.my_user.username);
        $modal.find('.match-info a').attr('href', '/members/user/profile/?duid='+json.user.duid);
        $modal.find('.match-info img').attr('src', json.user.pic);
        $modal.find('.match-info span').html(json.user.username);
        $modal.find('.swipe-send-msg').data('duid', json.user.duid);
        $modal.find('.quick-send-success').addClass('hide');
        $modal.find('.quick-send-fail').addClass('hide');

        if (json.allow_send_msg === false) {
            $modal.find('#quick-send').hide();

            // show yellow upgrade btn if FREE or unconverted trial user
            if (GP.sdata.my_user.membership == 'FREE' || GP.sdata.my_user.unconverted_trial) {
                $modal.find('#upgrade-btn').removeClass('hide');
            }
        } else {
            $modal.find('.hon-match-message').val('');
            $modal.find('.hon-match-send-msg').val(json.user.duid);
            $modal.find('#quick-send').show();

            $('#quick-send').one('submit', function(e) {
                e.preventDefault();

                var $form = $(this);

                GP.api.json('msg.add_message', {
                    type: 'POST',
                    data: $form.serialize(),
                }).done(function(json) {
                    $('#hon-match-modal').find('#quick-send').hide();

                    if (json.error) {
                        $('#hon-match-modal').find('.quick-send-fail').removeClass('hide');

                        // show yellow upgrade btn if FREE or unconverted trial user
                        if (GP.sdata.my_user.membership == 'FREE' || GP.sdata.my_user.unconverted_trial) {
                            setTimeout(function() {
                                $('#hon-match-modal').find('.quick-send-fail').addClass('hide');
                                $('#hon-match-modal').find('#upgrade-btn').removeClass('hide');
                            }, 2000);
                        }

                    } else {
                        $('#hon-match-modal').find('.quick-send-success').removeClass('hide');
                    }
                }).always(function() {
                    setTimeout(function() {
                        $(window).scrollTop(0);
                        $('#hon-match-modal').modal('hide');
                    }, 2000);
                });
            });
        }

        GP.vent.trigger('Modal:open:static', { modal_div_id: '#hon-match-modal' }, fireConfetti());
    };

    self.like = function() {
        $("#hotpick-swipe").jTinder('like');
    };

    self.dislike = function() {
        $("#hotpick-swipe").jTinder('dislike');
    };

    self.destroy = function() {
        $.removeData($("#hotpick-swipe").get(0));
    };

    self.hide_notify = function() {
        $('.hotpick-notify-wrap').addClass('hide');
        hotpick_notify.attr('checked', false);
    };

    // init
    if (typeof(_load_hotornot) != 'undefined' && _load_hotornot) {
        self.get_swipe_users(true);
    }

    $("#hotpick-like").click(function() {
        if (!processing) {
            processing = true;
            self.like();
        }
    });

    $("#hotpick-dislike").click(function() {
        if (!processing) {
            processing = true;
            self.dislike();
        }
    });

    $("#hotpick-refresh").click(function() {
        if (!processing) {
            processing = true;
            self.destroy();
            self.get_swipe_users(true, true);
        }
    });

    $("#hotpick-favorite").click(function() {
        if (!processing) {
            self.add_favorite();
        }
    });

    $(".btn-verify-me").click(function() {
        self.handle_verify_me();
    });

    $(".btn-got-card-purchase").click(function() {
        if (GP.sdata.my_user.credits >= GET_ON_TOP_CREDIT_COST) {
            GP.vent.trigger('TopOfSearch:setup_get_on_top_modal');
            GP.vent.trigger('Modal:open:confirm', { 
                template: 'GET_ON_TOP',
            }, self.accept_get_on_top, self.cancel_get_on_top);
        } else {
            self.show_buy_credits_got();
        }
    });

    $(".btn-more-swipes").click(function() {
        self.show_more_swipes_modal();
    });

    self.update_swipe_totals = function() {

        var goal = 0;
        if (GP.sdata.my_user.gender != 'MAN') {
            goal = 50;
            var goal_msg = js_lang.hon_goal_50;
            if (hotpick_rated_today >= 50 && hotpick_rated_today < 200) {
                goal = 200;
                goal_msg = js_lang.hon_goal_200;
            } else if (hotpick_rated_today >= 200 && hotpick_rated_today < 400) {
                goal = 400;
                goal_msg = js_lang.hon_goal_400;
            } else if (hotpick_rated_today >= 400 && hotpick_rated_today < 800) {
                goal = 800;
                goal_msg = js_lang.hon_goal_800;
            } else if (hotpick_rated_today >= 800) {
                goal = 1000;
                goal_msg = js_lang.hon_goal_max;
            }
            $('.swipe-progress').attr('max', goal);
            $("#text-hotpick-goal-msg").html(goal_msg);
        } else {
            goal = _hon_voting_limit;
            $('.swipe-progress').attr('max', goal);
        }

        $('.text-swipe-counter').attr('data-value', hotpick_rated_today);
        $('.swipe-progress').attr('value', hotpick_rated_today);

        var counter_width_hp = (hotpick_rated_today / goal) * 100 + '%';
        $('.text-swipe-counter').css('width', counter_width_hp);

        var counter_width = '--value:'+(hotpick_rated_today / goal) * 100;
        $('.swipe-progress').attr('style', counter_width);
    };

    self.show_goal_50_reached = function() {
        if ($.cookie(stealth_mode_cookie_name)) {
            return;
        }

        var $modal = $('#hon-goal-modal');
        $modal.find('#activate_stealth').on('click', function(e){
            var rated_duid = $("#hotornot_form input[name='duid']").val();
            var reward_data = { activate_reward: 1, duid: rated_duid, reward: 'stealth_lvl_2' };
            $.post('/members/user/hot_or_not/', reward_data)
                .done(function(data) {
                    if (typeof data.activate_reward != 'undefined') {
                        var rewards = data.activate_reward;
                        if ($.isPlainObject(rewards)) {
                            for (var reward in rewards) {
                                if (rewards[reward]) {
                                    switch (reward) {
                                        case 'stealth_lvl_2':
                                            GP.vent.trigger('StealthMode:stealth_success', rewards);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                })
                .always(function() {
                    $modal.modal('hide');
            });
        });
        GP.Util.set_cookie(stealth_mode_cookie_name, 1, 1);
        GP.vent.trigger('Modal:open:static', { modal_div_id: '#hon-goal-modal' }, fireConfetti());
    };
    self.swipe_limit_reached = function(json) {
        $('#hotpick-swipe-list').hide();
        $('#swipe-action-buttons').hide();
        $('#swipe-counter').hide();
        $('.hotpick-item-after').hide();
        $('#hotpick-wrap .text-rate').hide();
        $('#hotpick_img_box').hide();
        $('.progress_dt > .text-rate-wrap').addClass('hide');

        // $('.text-hotpick-limit-msg').html(js_lang.hon_limit_reached);

        if (json && json.bronze_billing_url) {
            $('.text-hotpick-limit-msg').append('<h3>Thanks for playing!</h3><p class="desc">You have reached your daily limit of 25 votes, please come back tomorrow or you can send unlimited FREE likes, comments, and vote on match game 200/day by choosing a credits package.</p> <a href="' + json.bronze_billing_url + '" class="btn btn-primary no-follow">Choose a Credits Package</a>');
        } else {
            $('.text-hotpick-limit-msg').html(js_lang.hon_limit_reached);
        }
        $('.progress_dt > .limit-msg-wrap').removeClass('hide');

        // userhome
        $('.panel-swipe-game #hotpick-wrap').hide();
        $('.panel-swipe-game .limit-msg-wrap').removeClass('hide');

        if (GP.sdata.my_user.membership == 'FREE') {
            GP.vent.trigger('Page:billing_redirect', {billing_header: 'hotornot_limit'});
        } else if (GP.sdata.my_user.membership == 'PENDING_FREE') {
            GP.vent.trigger('Page:pending_free_redirect');
        }
    };
    self.swipe_limit_reached_bronze = function(json) {
        $('#hotpick_img_box').hide();
        $('.progress_dt').hide();

        self.show_more_swipes_card();

        $('.progress_dt > .limit-msg-wrap').removeClass('hide');

        // userhome
        $('.text-hotpick-limit-msg').html(js_lang.hon_limit_reached);
        $('.panel-swipe-game #hotpick-wrap').hide();
        $('.panel-swipe-game .limit-msg-wrap').removeClass('hide');
        $('.panel-swipe-game .text-hotpick-full-ver').removeClass('hide');
    };
    self.swipe_users_reached = function() {
        $('#hotpick-swipe-list').hide();
        $('#swipe-action-buttons').hide();
        $('#swipe-counter').hide();
        $('.hotpick-item-after').hide();
        $('#hotpick-wrap .text-rate').hide();
        $('#home-wrap #hotpick-wrap').hide();
        $('#no-more-users-notice').show();
    };
    self.show_1_day_featured_reached = function() {
        GP.vent.trigger('Modal:open:alert', {
            template: 'FEATURE_PROFILE_FREE',
            sprintf: js_lang.hon_1_day_featured_reached,
            msg2: js_lang.hon_goal_400
        });
    };
    self.show_7_days_featured_reached = function() {
        GP.vent.trigger('Modal:open:alert', {
            template: 'FEATURE_PROFILE_FREE',
            sprintf: js_lang.hon_7_days_featured_reached,
            msg2: js_lang.hon_goal_800
        });
    };
    self.show_30_days_featured_reached = function() {
        GP.vent.trigger('Modal:open:alert', {
            template: 'FEATURE_PROFILE_FREE',
            sprintf: js_lang.hon_30_days_featured_reached,
            msg2: js_lang.hon_goal_max
        });
    };
    self.add_favorite = function() {
        var $_jtinder = $("#hotpick-swipe").jTinder();
        var _item = $_jtinder.data('plugin_jTinder').getCurrentPane().find('.media-item');

        $.post('/members/network/add_favorite', {
            fduid: _item.attr('duid'),
            process: 1
        }
        ).done(function(json) {
            if (typeof json.status != 'undefined' && json.status) {
                $('#hotpick-favorite').addClass('favorited');
            }
        });
    };
    self.reset_favorite_btn = function() {
        $('#hotpick-favorite').removeClass('favorited');
    };
    self.show_upload_notice = function() {
        $('#upload-pic-notice').show();
        $('#hotpick-swipe').hide();
        $('#swipe-action-buttons').hide();
    };
    self.show_upload_notice_x = function() {
        $('#upload-pic-notice-x').show();
        $('#hotpick-swipe').hide();
        $('#swipe-action-buttons').hide();
    };
    self.check_verified_card = function(_rated_today) {
        var _ver_cookie = $.cookie(verified_card_cookie_name);
        _ver_cookie = typeof _ver_cookie !== 'undefined';

        if (
            GP.sdata.my_user.verified_pic === 'N'
            && GP.sdata.my_user.verified_pic_pending === 'N'
            && _rated_today === verified_limit
            && !_ver_cookie
        ) {
            self.show_verified_card();
            self.set_verfied_card_cookie();
        }
    };
    self.show_verified_card = function() {
        var $verified_clone = $('.verified-card-wrap').clone();
        $verified_clone.css('display', 'block');

        $('#hotpick-swipe-list').append($verified_clone);
        self.destroy();
        self.setup_jTinder();
    };
    self.hide_verified_card = function() {
        $('#swipe-action-buttons.match-game-page').show();
        $('.verified-card-wrap').hide();
        self.set_verfied_card_cookie();
    };
    self.show_more_swipes_card = function() {
        $('.purchase-swipes-wrap').show();
    };
    self.hide_more_swipes_card = function() {
        $('#swipe-action-buttons.match-game-page').show();
        $('.purchase-swipes-wrap').hide();
    };
    self.handle_verify_me = function() {
        self.set_verfied_card_cookie();
    };
    self.set_verfied_card_cookie = function() {
        GP.Util.set_cookie(verified_card_cookie_name, 1, 1);
    };

    self.check_got_card = function(_rated_today) {
        var _got_cookie = $.cookie(got_card_cookie_name);
        _got_cookie = typeof _got_cookie !== 'undefined';

        // Don't show card if already on top.
        if (GP.sdata.my_user.get_on_top && GP.sdata.my_user.get_on_top.on_top) {
            return;
        }

        if (_rated_today === get_on_top_limit && !_got_cookie && (GP.sdata.my_user.membership !== 'FREE' || GP.sdata.my_user.can_oneclick)) {
            self.show_got_card();
            self.set_got_card_cookie();
        }
    };
    // show modal for get on top credits
    self.show_buy_credits_got = function() {
        GP.vent.trigger('Modal:open', {
            url: '/members/billing/top_of_search_modal/',
        });
    };
    self.show_got_card = function() {
        var $got_card_clone = $('.got-card-wrap').clone();
        $got_card_clone.css('display', 'block');

        $('#hotpick-swipe-list').append($got_card_clone);
        self.destroy();
        self.setup_jTinder();
    };
    self.show_got_modal = function() {
        if (GP.sdata.my_user.credits >= GET_ON_TOP_CREDIT_COST) {
            GP.vent.trigger('TopOfSearch:setup_get_on_top_modal');
            GP.vent.trigger('Modal:open:confirm', { 
                template: 'GET_ON_TOP',
             }, self.accept_get_on_top, self.cancel_get_on_top);
        } else {
            self.show_buy_credits_got();
        }
    };
    self.set_got_card_cookie = function() {
        GP.Util.set_cookie(got_card_cookie_name, 1, 1);
    };
    self.accept_get_on_top = function() {
        // purchase Get On Top
        GP.vent.trigger('TopOfSearch:get_on_top');
    };
    self.cancel_get_on_top = function() {
        console.log('purchase CANCELED');
    };
    self.show_verified_modal = function() {
        GP.vent.trigger('Modal:open', {
            url: '/members/user/verify/?self_view=1',
        });
    };
    GP.vent.on("hotpick:get_swipe_users", function() {
        self.get_swipe_users(true);
    });
    self.show_more_swipes_modal = function() {
        GP.vent.trigger('Modal:open', {
            url: '/members/billing/purchase_more_swipes',
        });
    };
});

GP.vent.on("hotpick:hide_upload_notice", function() {
    if ($('#upload-pic-notice').is(':visible')) {
        $('#upload-pic-notice').hide();
        $('#hotpick-swipe').show();
        $('#swipe-action-buttons').show();
        GP.vent.trigger('hotpick:get_swipe_users');
    }
 });
